import { useState, useEffect, useContext } from "react";
import appConfig from "../../config/app"
import { AuthContext } from "../../providers/auth"
import { Grid, CssBaseline, Box, Stack } from "@gti-controls-v2/web-core";
import SidebarSearch from "../../components/sidebar-search";
import AppBar from "../../components/app-bar"
import { DialogoSesionFinalizo } from "../../components/DialogoSesionFinalizo/DialogoSesionFinalizo";
import Backdrop from "../../components/backdrop";
import { refreshService } from "../../common/services/auth-service";
import homePageStyles from "../../common/styles/HomePage";

/** Estructura de Home Page */
export default function HomePageLayout(props) {
	const styles = homePageStyles;

	/** Estado de la forma */
    const { user, refresh } = useContext(AuthContext);
	const [sesionFinalizo, setSesionFinalizo] = useState(false);

	// Revisa cada 5 segundo si la sesion ya expiro
	useEffect(() => {
		const checkSesionFinalizo = async () => {
            try {

                //Cuando la fecha futura del token sea menor a la fecha actual, se finaliza la sesion
                if (new Date(user.token_expires_at) < new Date()) {
					const requestRefesh = {
						RefreshToken: user.refresh_token,
						AccessToken: user.token
					};
					
					const responseRefresh = await refreshService(requestRefesh);

					let refreshData = {
						user: null,
						auth: false
					};

					if (responseRefresh === null) {
						setSesionFinalizo(true);
						refresh(refreshData);
					} else {
						const token = responseRefresh.AuthenticationResult.AccessToken;
						const token_exp = responseRefresh.AuthenticationResult.ExpiresIn;
						const token_expires_at = new Date();
						token_expires_at.setSeconds(token_expires_at.getSeconds() + token_exp);

						refreshData = {
							user: {
								...user,
								token: token,
								token_expires_in: token_exp,
								token_expires_at: token_expires_at
							},
							auth: true
						};
						refresh(refreshData);
					}
					
                    //Borro el intervalo para que no se siga ejecutando cada 5 seg.
                    clearInterval(intervalId);
                }
            } catch (err) {
                console.error('Error validar expiración de token:', err);
            }
        }

		// Check immediately when component mounts
        checkSesionFinalizo();

        // Set up interval to check every 5 seconds
        const intervalId = setInterval(checkSesionFinalizo, 5000);

        // Clear interval when component unmounts
        return () => clearInterval(intervalId);

        // eslint-disable-next-line
	}, []);

	return (
		<Grid id="grid-main-homepage-layout" container component="main" sx={styles.root}>
			<CssBaseline />
			
			<AppBar />
			
			<Stack direction="row" sx={styles.mainPlusSidebar}>
				{ !props.isForm && <SidebarSearch /> }
				
				<DialogoSesionFinalizo sesionFinalizo={sesionFinalizo} />

				<Box sx={styles.main} id="box-container-content">
					<Backdrop />
					{props.children}
				</Box>
			</Stack>

			<Box sx={styles.imageContainer}>
				{"Versión: " + appConfig.APP_VERSION}
			</Box>
		</Grid>
	);
};